import { render } from "./DocStock.vue?vue&type=template&id=0ce47208&scoped=true&ts=true"
import script from "./DocStock.vue?vue&type=script&lang=ts"
export * from "./DocStock.vue?vue&type=script&lang=ts"

import "./DocStock.vue?vue&type=style&index=0&id=0ce47208&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce47208"]])

export default __exports__